import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import MDButton from "components/MDButton";
// @mui material components
import DeleteIcon from "@mui/icons-material/Delete";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import { CircularProgress } from "@mui/material";
// Material Dashboard 2 React examples
import DataTable from "examples/Tables/DataTable";
// Data
// import data from "layouts/dashboard/genre/data";
import EditIcon from "@mui/icons-material/Edit";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Table, TableBody, TableRow, TableCell } from "@mui/material";
import { Button, Dialog, DialogTitle, DialogContent, TextField } from "@mui/material";
import { IconButton } from "@mui/material";
import { Cancel as CancelIcon } from "@mui/icons-material";
import { orange } from "@mui/material/colors";
import { getHobbyData } from "../../redux/slices/hobbyDataSlice";
import { baseUrl } from "services/axiosInstance";
import HobbyDialog from "./HobbyDialog";
import { deleteHobby } from "services/apis";
import { deleteCategory } from "services/apis";
import { useLocation } from "react-router-dom";

export const HandleRows = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const selectedCategoryId = searchParams.get("categoryId");

  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    if (selectedCategoryId) {
      setExpanded(`panel-${selectedCategoryId}`); // match with accordion panel id
    }
  }, [selectedCategoryId]);
  const { hobbyData } = useSelector((state) => state.hobbyData);
  const [open, setOpen] = useState(false);
  const [HobbyId, setHobbyId] = useState(null);

  const handleOpen = (id) => {
    setOpen(true);
    setHobbyId(id);
  };

  const handleDelete = async (hobbyId) => {
    // Show confirmation dialog
    const result = await Swal.fire({
      icon: "warning",
      title: "Do you want to delete this hobby?",
      showDenyButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "No",
    });

    // If user confirms deletion
    if (result.isConfirmed) {
      try {
        // Call the deleteHobby API with the hobbyId
        const response = await deleteHobby({ "hobbyId": hobbyId });

        // Check if the deletion was successful
        if (response.success) {
          // Show success message
          await Swal.fire({
            icon: "success",
            title: "Hobby Deleted",
            timer: 1500,
            showConfirmButton: false,
          }).then(() => {
            dispatch(getHobbyData());
          });
        } else {
          // Handle API response indicating failure
          throw new Error(response.message || "Failed to delete hobby");
        }
      } catch (error) {
        console.error("Error deleting hobby:", error);

        // Show error message
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: error.message || "There was an error deleting this hobby.",
        });
      }
    }
  };

  const handleCategoryDelete = async (categotyId) => {
    // Show confirmation dialog
    const result = await Swal.fire({
      icon: "warning",
      title: "Do you want to delete this category?",
      showDenyButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "No",
    });

    // If user confirms deletion
    if (result.isConfirmed) {
      try {
        // Call the deleteHobby API with the categotyId

        const response = await deleteCategory({ "hobbyCatId": categotyId });

        // Check if the deletion was successful
        if (response.success) {
          // Show success message
          await Swal.fire({
            icon: "success",
            title: "Category Deleted",
            timer: 1500,
            showConfirmButton: false,
          }).then(() => {
            dispatch(getHobbyData());
          });
        } else {
          // Handle API response indicating failure
          throw new Error(response.message || "Failed to delete category");
        }
      } catch (error) {
        console.error("Error deleting category:", error);

        // Show error message
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: error.message || "There was an error deleting this category.",
        });
      }
    }
  };

  return (
    <MDBox>
      {hobbyData?.map((hobby, index) => (
        <MDBox key={index} mb={2} px={2}>
          <Accordion
            expanded={expanded === `panel-${hobby.id}`}
            onChange={() =>
              setExpanded(expanded === `panel-${hobby.id}` ? null : `panel-${hobby.id}`)
            }
          >

            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${index}-content`}
              id={`panel${index}-header`}
            >
              <MDBox
                mr={2}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <MDTypography
                  variant="h5"
                  fontWeight="bold"
                  sx={{
                    overflow: "auto",
                    textTransform: "capitalize",
                    wordWrap: "break-word",
                    maxWidth: { xs: "100%", sm: "75%" },
                  }}
                >
                  {hobby.category}
                </MDTypography>

                {/* Updated MDBox to align buttons in a single line */}
                <MDBox
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1, // Adds spacing between buttons
                  }}
                >
                  <MDButton
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpen(hobby.id);
                    }}
                    size="small"
                    variant="gradient"
                    color="light"
                  >
                    <MDTypography style={{ fontSize: "13.5px", fontWeight: "bold" }} color="white">
                      Add Hobby
                    </MDTypography>
                  </MDButton>

                  <IconButton
                    aria-label="delete"
                    color="secondary"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCategoryDelete(hobby.id);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </MDBox>
              </MDBox>
            </AccordionSummary>
            <AccordionDetails>
              <Table>
                <TableBody>
                  {hobby.hobbies.map((hobbie) => (
                    <TableRow key={hobbie.id}>
                      <TableCell>
                        <img
                          src={baseUrl + hobbie.icon} // Add your base URL here
                          alt={hobbie.hobbieName}
                          style={{ width: 30, height: 30 }}
                        />
                      </TableCell>
                      <TableCell>{hobbie.hobbieName}</TableCell>
                      <TableCell>{new Date(hobbie.createdAt).toLocaleDateString()}</TableCell>
                      <TableCell>
                        <MDBox
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          <IconButton
                            aria-label="delete"
                            color="secondary"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDelete(hobbie.id);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </MDBox>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </AccordionDetails>
          </Accordion>
        </MDBox>
      ))}
      <HobbyDialog {...{ open, setOpen, HobbyId, setHobbyId }} />
    </MDBox>
  );
};
